var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoGridcredit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#4E4E50;stroke-width:3.1389;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#F89C46;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "80.3,87.2 56.5,5.8 32.7,87.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.7,87.2c0.2,0.2,37.8-33.7,37.8-33.7L48.3,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.3,87.2C80,87.5,42.5,53.6,42.5,53.6l22.1-19.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "43.9,22.4 87,22.4 87,30.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 75.2,
    y1: 15.8,
    x2: 75.2,
    y2: 22.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.6,5.9c9.1,0,16.5,7.4,16.5,16.5c0,9.1-7.4,16.5-16.5,16.5c-9.1,0-16.5-7.4-16.5-16.5 C4.1,13.3,11.5,5.9,20.6,5.9 M20.6,2.8C9.8,2.8,1,11.5,1,22.4S9.8,42,20.6,42s19.6-8.8,19.6-19.6S31.4,2.8,20.6,2.8L20.6,2.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.9,21.1l-1.3-0.3v-4.5c1.1,0.2,1.9,0.8,2.2,1.7c0.1,0.3,0.4,0.6,0.7,0.6h1.9c0.5,0,0.9-0.4,0.8-0.9 c-0.5-2.3-2.5-3.9-5.5-4.2v-0.8c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.8c-3.6,0.3-5.8,2.2-5.8,5.2c0,2.5,1.6,4.2,4.5,4.9 l1.3,0.3v4.7c-1.3-0.1-2.2-0.8-2.6-1.8c-0.1-0.3-0.4-0.6-0.7-0.6h-2c-0.5,0-0.8,0.4-0.8,0.9c0.4,2.5,2.7,4,6.1,4.2v0.7 c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.7c3.8-0.3,6-2.2,6-5.3C27.5,23.4,26,21.8,22.9,21.1z M19.9,20.5 c-1.5-0.3-2.3-1-2.3-2.1c0-1.2,0.9-2,2.3-2.1V20.5z M21.6,28.6v-4.4c1.7,0.3,2.5,1.1,2.5,2.2C24.1,27.7,23.2,28.5,21.6,28.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGridcredit);
export default __webpack_public_path__ + "static/media/ico_gridcredit.38d5df671cc51c8a0260ee65504311c1.svg";
export { ForwardRef as ReactComponent };